import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  MatSnackBarConfig,
  MatSnackBarHorizontalPosition,
  MatSnackBar,
} from '@angular/material/snack-bar';
// Angular Editor Supprimer
// import { AngularEditorConfig } from '@kolkov/angular-editor';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UserContext } from '@unilog/template';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Inject, LOCALE_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { map } from 'lodash';
declare var XLSX: any;
declare var $: any;
// import { UserManagerService } from '@unilog/template/lib/shared/services/user-manager.service';
@Injectable({ providedIn: 'root' })
export class GeneralService {
  public user;
  public userPerso;
  exist: boolean;
  constructor(
    public translate: TranslateService,
    @Inject(LOCALE_ID) private _locale: string,
    public http: HttpClient,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private userContext: UserContext
  ) {
    this.getUser();
  }
  getUser() {
    this.userContext.getUserInfo().subscribe((user: any) => {
      this.user = user;
      this.rechercheTable(
        'recherche/tbdata?tablere=avtuser&param=' + user.userName
      ).subscribe((data) => {
        this.collaborateurConnecter = data[0].Perso_Matricule;
      });
    });
  }

  getImageQr(code) {
    return this.http.get(
      'http://196.179.235.24:86/api/pointageuniges/QRCode?code=' + code,
      { responseType: 'blob' }
    );
  }

  //api="http://41.228.44.149:86/api/";
  // api="http://unilog.ddns.net:86/api/";
  //api="http://serverp.pmc.tn:86/api/";
  //domaine = "https://backend-uniges.pmc.tn"

  domaine = environment.apiEndPoint;
  flatEndPoint = environment.flatEndPoint;
  api = this.domaine;
  imageDomain = this.flatEndPoint + 'images/articles/';
  url = 'recherche/tbdata?tablere=';
  imageDomainUpload = this.flatEndPoint + 'images/';
  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionlpc&param=20200101,20200505,%,%
  //liste action + actionD + client + perso pour une date de debut et de fin
  //et on à le chois d'ajouter un filtrer pour code perso ou/et client ou aucune de c deriner
  //premiere % : perso
  //desiemme % : client
  //=>         : &param=20200101,20200505,0139,C0037
  urlListeActionActionDClientPerso = this.url + 'avtActionlpc&param=';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=article
  //liste article
  urlListeArticle = this.url + 'article';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=DiverSys&param=0050
  //liste parametre
  urlListeParametre = this.url + 'DiverSys&param=';

  //http://unilog.ddns.net:86/api/ds/formdata?code=DiverSys&val=0009
  //ds Parametre ou ds DiverSys
  urlParametre = 'ds/formdata?code=DiverSys';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtFilesAction&param=cv,collaborateur,190026
  //liste document par group  et type et File_Lien
  urlListeFilesAction = this.url + 'avtFilesAction&param=';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtFilesR&param=0041,cv,collaborateur
  //liste document par group et key et type
  urlListeFilesR = this.url + 'avtFilesR&param=';

  //liste document par group  et type
  urlListeFilesR2 = this.url + 'avtFilesR2&param=';

  //liste facture client(by code client) date debut et fin
  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtPieceTClient&param=20100101,20190501,SNCI
  urlListePieceTClient = this.url + 'avtPieceTClient&param=';

  //liste facture date debut et fin
  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtPieceTAll&param=20000101,20190501
  urlListePieceTAll = this.url + 'avtPieceTAll&param=';

  //liste facture Regler date debut et fin
  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtPieceTRegler&param=20100101,20190501
  urlListePieceTRegler = this.url + 'avtPieceTRegler&param=';

  //liste facture Non Regler date debut et fin
  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtPieceTNonRegler&param=20000101,20190501
  urlListePieceTNonRegler = this.url + 'avtPieceTNonRegler&param=';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionDjointureTiers&param=20170101,20200301
  //liste actionD date debut et fin + joiture sur Action + joiture sur tiers
  urlListeActionDjointureTiers = this.url + 'avtActionDjointureTiers&param=';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtListeActionD&param=20170101,20200301,8
  // liste actionD+ jointure action pour un col à une date debut et date fin
  urlListeActionActionDColl = this.url + 'avtListeActionD&param=';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionDClient&param=20170101,20200301,C0004
  // liste actionD+ jointure action pour un client à une date debut et date fin
  urlListeActionActionDClient = this.url + 'avtActionDClient&param=';

  // liste actionD pour lst col à une date debut et date fin
  // EX: http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtactionDColF&param=10;8;70,2018-12-1,2019-12-31
  urlavtactionDColDate = this.url + 'avtactionDColF&param=';

  // liste actionD pour lst col à une date debut et date fin
  // EX: http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionDEquip&param=10;8;70,2018-12-1,2019-12-31
  urlavtactionDMachineDate = this.url + 'avtActionDEquip&param=';

  // liste action pour une liste code actionD
  // Ex: http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionLAD&param=3521;3529;3532
  urlListeActionLAD = this.url + 'avtActionLAD&param=';

  // liste actionD pour une liste code action
  // Ex: http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionDLA&param=190008;190001
  urlavtActionDLA = this.url + 'avtActionDLA&param=';

  // liste action pour une code client
  // Ex: http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionClient&param=C0009
  urlListeActionClient = this.url + 'avtActionClient&param=';

  // Liste actionD à une date debut et date fin
  // ex: http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionDDF&param=2018-12-1,2019-12-31
  urlListeAvtActionDDF = this.url + 'avtActionDDF&param=';

  // Liste actionD à une date debut et date fin et code action
  // ex: http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionDDF1&param=190001,20181201,20191231
  urlListeAvtActionDDFCodeAction = this.url + 'avtActionDDF1&param=';

  // liste collaborateur pour une liste de code de competance
  // ex: http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtColaboComp&param=ACC1,RespLbabo,RMQ,Sdp
  urlListeColaboComp = this.url + 'avtColaboComp&param=';

  // liste frais pour une liste de code de coll à une date debut et date fin
  // ex: http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtFraisColaboDDF&param=10,2018-12-1,2019-12-31
  urlListeFraisColaboDDF = this.url + 'avtFraisColaboDDF&param=';

  //liste action pour une date debut et fin et type action
  // http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionListDDF&param=2018-11-2,2019-11-3,0
  urlActionListDDF = this.url + 'avtActionListDDF&param=';

  // liste action pour une liste de code collabo
  // ex: http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionUnCol&param=10;9
  urlListeActionCol = this.url + 'avtActionUnCol&param=';

  //liste des taux de km
  // ex http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtTauxKm
  urlListTauxKm = this.url + 'avtTauxKm';

  // model de document pour nouveau coll documents
  urlListeDocument = this.url + 'avtDocument';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionReferent&param=190027
  //liste referent action
  urlListeActionReferent = this.url + 'avtActionReferent&param=';

  //select max id avtdocMaxId
  urlavtdocMaxId = this.url + 'avtdocMaxId';

  //liste document pour un collaboaeteur
  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtFiles&param=10,collaborateur
  urlListeDocColl = this.url + 'avtFiles&param=';

  //recherche document par code: retourne un document coder en base46
  // http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtFilesContent&param=213
  urlDoc = this.url + 'avtFilesContent&param=';

  //recherche document par code: retourne un document coder en base46
  // http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtFilesC&param=0041,collaborateur,cv
  urlFindDoc = this.url + 'avtFilesC&param=';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtListeClient
  //tous les Client: code + non + type
  urlSelectClient = this.url + 'avtListeClient';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=ListePerso
  //tous les Perso: code + non + type
  urlSelectPerso = this.url + 'avtListePerso';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=listeAvtAction
  //tous les Action: code + non + type
  urlSelectAction = this.url + 'avtlisteAction';

  //http://unilog.ddns.net:86/api/ds/formdata?code=crmactivity
  //ds CrmactivityD pour echange client
  urlCrmactivity = 'ds/formdata?code=crmactivity';

  //http://unilog.ddns.net:86/api/ds/formdata?code=tiersC
  //ds Interlocuteur
  urlInterlocuteur = 'ds/formdata?code=tiersC';

  //http://unilog.ddns.net:86/api/ds/formdata?code=avtalerte
  //ds alerte
  urlAlert = 'ds/formdata?code=avtalerte';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtCRMActivity&param=c0034
  //liste activity pour code client
  urlListeCRMActivity = this.url + 'avtCRMActivity&param=';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avttiersc&param=1
  //liste Interlocuteur
  urlListeInterlocuteur = this.url + 'avttiersc&param=';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtalerte&param=c0056
  //liste Alert pour un code client
  urlListeAlert = this.url + 'avtalerte&param='; //

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=persocontrat
  //liste Alert
  urlListeContrat = this.url + 'persocontrat'; //

  //http://unilog.ddns.net:86/api/recherche/TbRecherche?param=avtalerte
  //Column Alert
  urlColumnAlert = 'recherche/TbRecherche?param=avtAlerte2' + 'avtalerte'; //

  //http://unilog.ddns.net:86/api/recherche/TbRecherche?param=avtCRMActivity
  //Column CRMActivity
  urlColumnCRMActivity = 'recherche/TbRecherche?param=avtCRMActivity'; //

  //http://unilog.ddns.net:86/api/recherche/TbRecherche?param=avttiersc
  //Column Interlocuteur
  urlColumnInterlocuteur = 'recherche/TbRecherche?param=avttiersc'; //

  //http://unilog.ddns.net:86/api/recherche/TbRecherche?param=avttiersc
  //Column Alert
  urlColumnEchanfes = 'recherche/TbRecherche?param=avttiersc';

  //http://unilog.ddns.net:86/api/gesfiles/contratWordSQL?matricule=0106
  urlContratDocx = this.api + 'files/contratWordSQL?matricule=';

  //http://unilog.ddns.net:86/api/ds/formdata?code=persocontrat
  // ds contrat
  urlpersocontrat = 'ds/formdata?code=persocontrat';

  //http://unilog.ddns.net:86/api/ds/formdata?code=menu&val=ahmed
  //ds menu
  urlMenu = 'ds/formdata?code=menu';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=menu
  //liste menu droit d'accer
  urlListeMenu = this.url + 'menu';

  //https://backend-uniges.pmc.tn/api/recherche/tbdata?tablere=avtusers
  //url liste user
  urlListeUtilisateur = this.url + 'avtusers';

  //http://unilog.ddns.net:86/api/ds/formdata?code=users
  //ds user
  urlUser = 'ds/formdata?code=users';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtmenu
  //liste droit d'accer (fonctions)
  urlListeDroitAccer = this.url + 'avtmenu';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtFilesType&param=avtContrat
  urlListeAllDocumentContrat = this.url + 'avtFilesType&param=avtContrat';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=ApplyCursus
  //liste cursus
  urlListeApplyCursus = this.url + 'ApplyCursus';

  //liste des matiere pour un code cursus
  //http://unilog.ddns.net:86/api/ds/formdata?code=ApplyCursusD
  //ds CursusD
  urlApplyCursusD = 'ds/formdata?code=ApplyCursusD';

  //liste des cursus
  //http://unilog.ddns.net:86/api/ds/formdata?code=ApplyCursus
  //ds Cursus
  urlApplyCursus = 'ds/formdata?code=ApplyCursus';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=ApplyCursusD
  //liste cursusD
  urlListeApplyCursusD = this.url + 'ApplyCursusD';

  //http://unilog.ddns.net:86/api/recherche/TbRecherche?param=machine
  urlColumnMachine = 'recherche/TbRecherche?param=machine';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=machine
  //liste machine
  urlListeMachine = this.url + 'machine';

  //http://unilog.ddns.net:86/api/ds/formdata?code=Machine
  //ds machine
  urlMachine = 'ds/formdata?code=Machine';

  //http://unilog.ddns.net:86/api/ds/formdata?code=MachineNom&val=m1
  //ds Fils machine
  urlFilsMachine = 'ds/formdata?code=MachineNom';

  //http://unilog.ddns.net:86/api/ds/formdata?code=avtActionType
  //ds TypePresenceAction
  urlTypePresenceAction = this.api + 'avtActionType';
  //http://unilog.ddns.net:86/api/ds/formdata?code=avtActionTypeD
  //ds avtActionTypeD
  urlAvtActionTypeD = 'ds/formdata?code=avtActionTypeD';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=client&val=pmc
  // liste client Tiers_Code et Tiers_RS avec val optionnel
  urlListeClient = this.api + 'client';

  urlPrintPiece = 'report/pdf?code=tm.rdl';
  urlListeParamAction = this.url + 'avtParamAction';
  urlListeParamColl = this.url + 'avtParamColl';
  //liste collaborateur ou apprenant
  urlListPerso = this.url + 'avtperso&param=';
  urlListFraisCollaborateur = this.url + 'avtExtFraisMens';
  urlListClientFull = this.url + 'tiers';
  urlListClient = this.url + 'avtclient2';
  urlListActionFull = this.url + 'avtAction';
  urlListAction = this.url + 'avtActionList';
  urlListActionD = this.url + 'avtActionDList';
  urlListActionDSearch = this.url + 'avtActionDcol&param=';
  urlListActionDSearch2 = this.url + 'avtActionDPerso&param=';
  urlListCompetence = this.url + 'GRHComp';
  urlListeActionDFull = this.url + 'avtActionDTot';
  urlEntetFraisCollaborateur = 'recherche/TbRecherche?param=avtExtFraisMens';
  urlListeFraisFull = this.url + 'avtfrais';

  urlColumnCollaborateur = 'recherche/TbRecherche?param=avtcollaborateur';
  urlColumnClientaborateur = 'recherche/TbRecherche?param=avtclient';

  urlListeClientByType = this.url + 'avtclient&param=';
  //http://unilog.ddns.net:86/api/ds/formdata?code=avtHeureParam
  //ds avtParamHeure
  urlParamHeure = 'ds/formdata?code=avtHeureParam';

  //http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtHeureParam
  //liste avtParamHeure
  urlListeParamHeure = this.url + 'avtHeureParam';

  //http://unilog.ddns.net:86/api/ds/formdata?code=avtParamAction
  //ds avtParamAction
  urlParamAction = 'ds/formdata?code=avtParamAction';

  //http://unilog.ddns.net:86/api/ds/formdata?code=GRHComp
  //ds competance
  urlCompetance = 'ds/formdata?code=GRHComp';

  urlParamColl = 'ds/formdata?code=avtParamColl';

  urlFiles = 'ds/formdata?code=avtFiles';
  //liste actionD pour code action
  urlActionD = 'ds/formdata?code=avtactiond&val=';
  urlAction = 'ds/formdata?code=avtaction';
  //retourne actionD vide
  urlActionD2 = 'ds/formdata?code=avtactiond2';
  //ds client
  urlClient = 'ds/formdata?code=avtclient';
  //ds perso //ds collaborateur
  urlPerso = 'ds/formdata?code=avtPerso';
  urlAvtfrais = 'ds/formdata?code=avtfrais';
  urlAvtDoc = 'ds/ajout?dstables=files';

  tarificationEvennement = [
    { montantAfeterRemise: 0, montant: 120, TravelD_TypeEvent: 0 },
    { montantAfeterRemise: 0, montant: 170, TravelD_TypeEvent: 0 },
    { montantAfeterRemise: 0, montant: 50, TravelD_TypeEvent: 0 },
    { montantAfeterRemise: 0, montant: 55, TravelD_TypeEvent: 1 },
    { montantAfeterRemise: 0, montant: 85, TravelD_TypeEvent: 1 },
    { montantAfeterRemise: 0, montant: 100, TravelD_TypeEvent: 2 },
    { montantAfeterRemise: 0, montant: 90, TravelD_TypeEvent: 2 },
    { montantAfeterRemise: 0, montant: 80, TravelD_TypeEvent: 2 },
    { montantAfeterRemise: 0, montant: 70, TravelD_TypeEvent: 2 },
    { montantAfeterRemise: 0, montant: 80, TravelD_TypeEvent: 3 },
    { montantAfeterRemise: 0, montant: 150, TravelD_TypeEvent: 4 },
    { montantAfeterRemise: 0, montant: 130, TravelD_TypeEvent: 4 },
    { montantAfeterRemise: 0, montant: 30, TravelD_TypeEvent: 5 },
  ];
  listeTypeEvennement = [
    { text: 'RESTAURATION', TravelD_TypeEvent: 0, TravelD_TypFournisseur: '0' },
    {
      text: 'RESTAURATION HOTEL',
      TravelD_TypeEvent: 10,
      TravelD_TypFournisseur: '3',
    },
    { text: 'SITE', TravelD_TypeEvent: 1, TravelD_TypFournisseur: '1' },
    { text: 'TRAJET', TravelD_TypeEvent: 2, TravelD_TypFournisseur: '2' },
    { text: 'HEBERGEMENT', TravelD_TypeEvent: 3, TravelD_TypFournisseur: '3' },
    { text: 'EXCURSION', TravelD_TypeEvent: 4, TravelD_TypFournisseur: '4' },
    {
      text: 'SERVICE PAYANT',
      TravelD_TypeEvent: 5,
      TravelD_TypFournisseur: '5',
    },
    {
      text: 'SERVICE GRATUIT',
      TravelD_TypeEvent: 6,
      TravelD_TypFournisseur: '6',
    },
  ];
  listeEvennement = [
    { TravelD_Event: 'REPAS', evennemtCode: 0, TravelD_TypeEvent: '0' },
    { TravelD_Event: 'DINER ', evennemtCode: 1, TravelD_TypeEvent: '0' },
    {
      TravelD_Event: 'PETIT DEJEUNER ',
      evennemtCode: 4,
      TravelD_TypeEvent: '0',
    },
    { TravelD_Event: 'REPAS', evennemtCode: 0, TravelD_TypeEvent: '10' },
    { TravelD_Event: 'DINER ', evennemtCode: 1, TravelD_TypeEvent: '10' },
    {
      TravelD_Event: 'PETIT DEJEUNER ',
      evennemtCode: 4,
      TravelD_TypeEvent: '10',
    },
    { TravelD_Event: 'VISITE MEDINA', evennemtCode: 5, TravelD_TypeEvent: '1' },
    { TravelD_Event: 'VISITE SITE', evennemtCode: 6, TravelD_TypeEvent: '1' },
    {
      TravelD_Event: 'DEPLACEMENT VERS AEROPORT',
      evennemtCode: 7,
      TravelD_TypeEvent: '2',
    },
    {
      TravelD_Event: 'DEPLACEMENT VERS SITE',
      evennemtCode: 8,
      TravelD_TypeEvent: '2',
    },
    {
      TravelD_Event: 'DEPLACEMENT VERS VILLE',
      evennemtCode: 9,
      TravelD_TypeEvent: '2',
    },
    {
      TravelD_Event: "TRAJET VERS L'HOTEL",
      evennemtCode: 10,
      TravelD_TypeEvent: '2',
    },
    { TravelD_Event: 'TRASFERT BUS', evennemtCode: 11, TravelD_TypeEvent: '2' },
    {
      TravelD_Event: "NUIT A L'HOTEL",
      evennemtCode: 12,
      TravelD_TypeEvent: '3',
    },
    {
      TravelD_Event: 'EXCURSION EN 4X4',
      evennemtCode: 13,
      TravelD_TypeEvent: '4',
    },
    {
      TravelD_Event: 'EXCURSION EN CALECHEL',
      evennemtCode: 14,
      TravelD_TypeEvent: '4',
    },
    {
      TravelD_Event: 'EXCURSION EN CHAMAUX',
      evennemtCode: 15,
      TravelD_TypeEvent: '4',
    },
    {
      TravelD_Event: 'ACCOMPAGNEMENT AU DEPART ET AUREVOIR',
      evennemtCode: 16,
      TravelD_TypeEvent: '5',
    },
    {
      TravelD_Event: "ARRIVEE  A L'AEROPORT",
      evennemtCode: 17,
      TravelD_TypeEvent: '5',
    },
    {
      TravelD_Event: "ARRIVEE  A L'HOTEL / INSTALLATION",
      evennemtCode: 18,
      TravelD_TypeEvent: '5',
    },
    { TravelD_Event: 'POSE REPOS', evennemtCode: 19, TravelD_TypeEvent: '5' },
  ];
  listeType = [
    { text: 'DP', value: 0 },
    { text: 'PC', value: 1 },
    { text: 'LPD', value: 2 },
    { text: 'AUTRE', value: 3 },
  ];
  listeVille = [
    'AIN DRAHIM',
    'BIZERTE',
    'BULLA REGIA',
    'CAP BON',
    'DEN DEN',
    'DOUGGA',
    'DOUZ',
    'EL JEM',
    'GABES',
    'GAFSA',
    'HAMMAMET',
    'HAOUARIA',
    'JELMA',
    'JENDOUBA',
    'JERBA',
    'KAIROUAN',
    'KASSERINE',
    'KEBILI',
    'KEF',
    'KELIBIA',
    'KERKENAH',
    'KERKOUANE',
    'KORBA',
    'KSAR GHLANE',
    'MAHDIA',
    'MAKTHAR',
    'MANNOUBA',
    'MATMATA',
    'MEDENINE',
    'MONASTIR',
    'NABEUL',
    'NEFTA',
    'OUDHNA',
    'SBEITLA',
    'SFAX',
    'SIIDI BOUZID',
    'SILIANA',
    'SOUSSE',
    'TABARKA',
    'TAKROUNA',
    'TAMERZA',
    'TATAOUINE',
    'TEBURBO MAJUS',
    'TOZEUR',
    'TUNIS',
    'TUNIS - CARTHAGE',
    'TUNIS - GAMMARTH',
    'TUNIS CITY',
    'TUNIS-GOULETTE',
    'UTIQUE',
    'ZAGHOUAN',
    'ZERZIS',
  ];
  nationalitePays = [
    {
      id: 1,
      nationalite: 'afghane',
      libelle: 'Afghanistan',
    },
    {
      id: 2,
      nationalite: 'sudafricaine',
      libelle: 'Afrique du Sud',
    },
    {
      id: 3,
      nationalite: 'albanaise',
      libelle: 'Albanie',
    },
    {
      id: 4,
      nationalite: 'algérienne',
      libelle: 'Algérie',
    },
    {
      id: 5,
      nationalite: 'allemande',
      libelle: 'Allemagne',
    },
    {
      id: 6,
      nationalite: 'andorrane',
      libelle: 'Andorre',
    },
    {
      id: 7,
      nationalite: 'angolaise',
      libelle: 'Angola',
    },
    {
      id: 8,
      nationalite: 'antiguayenne',
      libelle: 'Antigua-et-Barbuda',
    },
    {
      id: 9,
      nationalite: 'saoudienne',
      libelle: 'Arabie saoudite',
    },
    {
      id: 10,
      nationalite: 'argentine',
      libelle: 'Argentine',
    },
    {
      id: 11,
      nationalite: 'arménienne',
      libelle: 'Arménie',
    },
    {
      id: 12,
      nationalite: 'australienne',
      libelle: 'Australie',
    },
    {
      id: 13,
      nationalite: 'autrichienne',
      libelle: 'Autriche',
    },
    {
      id: 14,
      nationalite: 'azerbaïdjanaise',
      libelle: 'Azerbaïdjan',
    },
    {
      id: 15,
      nationalite: 'bahaméenne',
      libelle: 'Bahamas',
    },
    {
      id: 16,
      nationalite: 'bahreïnienne',
      libelle: 'Bahreïn',
    },
    {
      id: 17,
      nationalite: 'bangladaise',
      libelle: 'Bangladesh',
    },
    {
      id: 18,
      nationalite: 'barbadienne',
      libelle: 'Barbade',
    },
    {
      id: 19,
      nationalite: 'belge',
      libelle: 'Belgique',
    },
    {
      id: 20,
      nationalite: 'bélizienne',
      libelle: 'Belize',
    },
    {
      id: 22,
      nationalite: 'bhoutanaise',
      libelle: 'Bhoutan',
    },
    {
      id: 24,
      nationalite: 'birmane',
      libelle: 'Birmanie',
    },
    {
      id: 23,
      nationalite: 'biélorusse',
      libelle: 'Biélorussie',
    },
    {
      id: 25,
      nationalite: 'bolivienne',
      libelle: 'Bolivie',
    },
    {
      id: 26,
      nationalite: 'bosnienne',
      libelle: 'Bosnie-Herzégovine',
    },
    {
      id: 27,
      nationalite: 'botswanaise',
      libelle: 'Botswana',
    },
    {
      id: 29,
      nationalite: 'brunéienne',
      libelle: 'Brunei',
    },
    {
      id: 28,
      nationalite: 'brésilienne',
      libelle: 'Brésil',
    },
    {
      id: 30,
      nationalite: 'bulgare',
      libelle: 'Bulgarie',
    },
    {
      id: 31,
      nationalite: 'burkinabé',
      libelle: 'Burkina',
    },
    {
      id: 32,
      nationalite: 'burundaise',
      libelle: 'Burundi',
    },
    {
      id: 21,
      nationalite: 'béninoise',
      libelle: 'Bénin',
    },
    {
      id: 33,
      nationalite: 'cambodgienne',
      libelle: 'Cambodge',
    },
    {
      id: 34,
      nationalite: 'camerounaise',
      libelle: 'Cameroun',
    },
    {
      id: 35,
      nationalite: 'canadienne',
      libelle: 'Canada',
    },
    {
      id: 36,
      nationalite: 'cap-verdienne',
      libelle: 'Cap-Vert',
    },
    {
      id: 144,
      nationalite: 'centrafricaine',
      libelle: 'Centrafrique',
    },
    {
      id: 37,
      nationalite: 'chilienne',
      libelle: 'Chili',
    },
    {
      id: 38,
      nationalite: 'chinoise',
      libelle: 'Chine',
    },
    {
      id: 39,
      nationalite: 'chypriote',
      libelle: 'Chypre',
    },
    {
      id: 40,
      nationalite: 'colombienne',
      libelle: 'Colombie',
    },
    {
      id: 41,
      nationalite: 'comorienne',
      libelle: 'Comores',
    },
    {
      id: 42,
      nationalite: 'congolaise',
      libelle: 'Congo',
    },
    {
      id: 43,
      nationalite: 'nord-coréenne',
      libelle: 'Corée du Nord',
    },
    {
      id: 44,
      nationalite: 'sud-coréenne',
      libelle: 'Corée du Sud',
    },
    {
      id: 45,
      nationalite: 'costaricienne',
      libelle: 'Costa Rica',
    },
    {
      id: 47,
      nationalite: 'croate',
      libelle: 'Croatie',
    },
    {
      id: 48,
      nationalite: 'cubaine',
      libelle: 'Cuba',
    },
    {
      id: 46,
      nationalite: 'ivoirienne',
      libelle: "Côte d'Ivoire",
    },
    {
      id: 49,
      nationalite: 'danoise',
      libelle: 'Danemark',
    },
    {
      id: 50,
      nationalite: 'djiboutienne',
      libelle: 'Djibouti',
    },
    {
      id: 51,
      nationalite: 'dominiquaise',
      libelle: 'Dominique',
    },
    {
      id: 52,
      nationalite: 'egyptienne',
      libelle: 'Egypte',
    },
    {
      id: 53,
      nationalite: 'emirienne',
      libelle: 'Emirats arabes unis',
    },
    {
      id: 54,
      nationalite: 'equatorienne',
      libelle: 'Equateur',
    },
    {
      id: 55,
      nationalite: 'erythréenne',
      libelle: 'Erythrée',
    },
    {
      id: 56,
      nationalite: 'espagnole',
      libelle: 'Espagne',
    },
    {
      id: 57,
      nationalite: 'estonienne',
      libelle: 'Estonie',
    },
    {
      id: 58,
      nationalite: 'américaine',
      libelle: 'Etats-Unis',
    },
    {
      id: 59,
      nationalite: 'ethiopienne',
      libelle: 'Ethiopie',
    },
    {
      id: 60,
      nationalite: 'fidjienne',
      libelle: 'Fidji',
    },
    {
      id: 61,
      nationalite: 'finlandaise',
      libelle: 'Finlande',
    },
    {
      id: 62,
      nationalite: 'française',
      libelle: 'France',
    },
    {
      id: 63,
      nationalite: 'gabonaise',
      libelle: 'Gabon',
    },
    {
      id: 64,
      nationalite: 'gambienne',
      libelle: 'Gambie',
    },
    {
      id: 66,
      nationalite: 'ghanéenne',
      libelle: 'Ghana',
    },
    {
      id: 68,
      nationalite: 'grenadienne',
      libelle: 'Grenade',
    },
    {
      id: 67,
      nationalite: 'grecque',
      libelle: 'Grèce',
    },
    {
      id: 69,
      nationalite: 'guatémaltèque',
      libelle: 'Guatemala',
    },
    {
      id: 70,
      nationalite: 'guinéenne',
      libelle: 'Guinée',
    },
    {
      id: 71,
      nationalite: 'equatoguinéenne',
      libelle: 'Guinée équatoriale',
    },
    {
      id: 72,
      nationalite: 'bissaoguinéenne',
      libelle: 'Guinée-Bissao',
    },
    {
      id: 73,
      nationalite: 'guyanienne',
      libelle: 'Guyana',
    },
    {
      id: 65,
      nationalite: 'géorgienne',
      libelle: 'Géorgie',
    },
    {
      id: 74,
      nationalite: 'haïtienne',
      libelle: 'Haïti',
    },
    {
      id: 75,
      nationalite: 'hondurienne',
      libelle: 'Honduras',
    },
    {
      id: 77,
      nationalite: 'hongroise',
      libelle: 'Hongrie',
    },
    {
      id: 79,
      nationalite: 'indienne',
      libelle: 'Inde',
    },
    {
      id: 80,
      nationalite: 'indonésienne',
      libelle: 'Indonésie',
    },
    {
      id: 81,
      nationalite: 'irakienne',
      libelle: 'Irak',
    },
    {
      id: 82,
      nationalite: 'iranienne',
      libelle: 'Iran',
    },
    {
      id: 83,
      nationalite: 'irlandaise',
      libelle: 'Irlande',
    },
    {
      id: 84,
      nationalite: 'islandaise',
      libelle: 'Islande',
    },
    {
      id: 86,
      nationalite: 'italienne',
      libelle: 'Italie',
    },
    {
      id: 87,
      nationalite: 'jamaïquaine',
      libelle: 'Jamaïque',
    },
    {
      id: 88,
      nationalite: 'japonaise',
      libelle: 'Japon',
    },
    {
      id: 90,
      nationalite: 'jordanienne',
      libelle: 'Jordanie',
    },
    {
      id: 89,
      nationalite: 'palestinienne',
      libelle: 'Jérusalem - Territoires palestiniens',
    },
    {
      id: 91,
      nationalite: 'kazakhstanais',
      libelle: 'Kazakhstan',
    },
    {
      id: 92,
      nationalite: 'kényane',
      libelle: 'Kenya',
    },
    {
      id: 93,
      nationalite: 'kirghize',
      libelle: 'Kirghizstan',
    },
    {
      id: 94,
      nationalite: 'kiribatienne',
      libelle: 'Kiribati',
    },
    {
      id: 198,
      nationalite: 'kosovare',
      libelle: 'Kosovo',
    },
    {
      id: 95,
      nationalite: 'koweïtienne',
      libelle: 'Koweït',
    },
    {
      id: 96,
      nationalite: 'laotienne',
      libelle: 'Laos',
    },
    {
      id: 97,
      nationalite: 'lesothienne',
      libelle: 'Lesotho',
    },
    {
      id: 98,
      nationalite: 'lettone',
      libelle: 'Lettonie',
    },
    {
      id: 99,
      nationalite: 'libanaise',
      libelle: 'Liban',
    },
    {
      id: 100,
      nationalite: 'libérienne',
      libelle: 'Liberia',
    },
    {
      id: 101,
      nationalite: 'libyenne',
      libelle: 'Libye',
    },
    {
      id: 102,
      nationalite: 'liechtensteinoise',
      libelle: 'Liechtenstein',
    },
    {
      id: 103,
      nationalite: 'lituanienne',
      libelle: 'Lituanie',
    },
    {
      id: 104,
      nationalite: 'luxembourgeoise',
      libelle: 'Luxembourg',
    },
    {
      id: 105,
      nationalite: 'macédonienne',
      libelle: 'Macédoine',
    },
    {
      id: 106,
      nationalite: 'malgache',
      libelle: 'Madagascar',
    },
    {
      id: 107,
      nationalite: 'malaisienne',
      libelle: 'Malaisie',
    },
    {
      id: 108,
      nationalite: 'malawienne',
      libelle: 'Malawi',
    },
    {
      id: 109,
      nationalite: 'maldivienne',
      libelle: 'Maldives',
    },
    {
      id: 110,
      nationalite: 'malienne',
      libelle: 'Mali',
    },
    {
      id: 111,
      nationalite: 'maltaise',
      libelle: 'Malte',
    },
    {
      id: 112,
      nationalite: 'marocaine',
      libelle: 'Maroc',
    },
    {
      id: 113,
      nationalite: 'marshallaise',
      libelle: 'Marshall',
    },
    {
      id: 114,
      nationalite: 'mauricienne',
      libelle: 'Maurice',
    },
    {
      id: 115,
      nationalite: 'mauritanienne',
      libelle: 'Mauritanie',
    },
    {
      id: 116,
      nationalite: 'mexicaine',
      libelle: 'Mexique',
    },
    {
      id: 117,
      nationalite: 'micronésienne',
      libelle: 'Micronésie',
    },
    {
      id: 118,
      nationalite: 'moldave',
      libelle: 'Moldavie',
    },
    {
      id: 119,
      nationalite: 'monégasque',
      libelle: 'Monaco',
    },
    {
      id: 120,
      nationalite: 'mongole',
      libelle: 'Mongolie',
    },
    {
      id: 197,
      nationalite: 'monténégrine',
      libelle: 'Monténégro',
    },
    {
      id: 121,
      nationalite: 'mozambicaine',
      libelle: 'Mozambique',
    },
    {
      id: 122,
      nationalite: 'namibienne',
      libelle: 'Namibie',
    },
    {
      id: 123,
      nationalite: 'nauruane',
      libelle: 'Nauru',
    },
    {
      id: 125,
      nationalite: 'nicaraguayenne',
      libelle: 'Nicaragua',
    },
    {
      id: 126,
      nationalite: 'nigérienne',
      libelle: 'Niger',
    },
    {
      id: 127,
      nationalite: 'nigériane',
      libelle: 'Nigeria',
    },
    {
      id: 128,
      nationalite: 'norvégienne',
      libelle: 'Norvège',
    },
    {
      id: 129,
      nationalite: 'néo-zélandaise',
      libelle: 'Nouvelle-Zélande',
    },
    {
      id: 124,
      nationalite: 'népalaise',
      libelle: 'Népal',
    },
    {
      id: 130,
      nationalite: 'omanaise',
      libelle: 'Oman',
    },
    {
      id: 131,
      nationalite: 'ougandaise',
      libelle: 'Ouganda',
    },
    {
      id: 132,
      nationalite: 'ouzbèke',
      libelle: 'Ouzbékistan',
    },
    {
      id: 133,
      nationalite: 'pakistanaise',
      libelle: 'Pakistan',
    },
    {
      id: 134,
      nationalite: 'palaoise',
      libelle: 'Palaos',
    },
    {
      id: 135,
      nationalite: 'panaméenne',
      libelle: 'Panama',
    },
    {
      id: 136,
      nationalite: 'papouasienne',
      libelle: 'Papouasie-Nouvelle-Guinée',
    },
    {
      id: 137,
      nationalite: 'paraguayenne',
      libelle: 'Paraguay',
    },
    {
      id: 138,
      nationalite: 'néerlandaise',
      libelle: 'Pays-Bas',
    },
    {
      id: 140,
      nationalite: 'philippine',
      libelle: 'Philippines',
    },
    {
      id: 141,
      nationalite: 'polonaise',
      libelle: 'Pologne',
    },
    {
      id: 142,
      nationalite: 'portugaise',
      libelle: 'Portugal',
    },
    {
      id: 139,
      nationalite: 'péruvienne',
      libelle: 'Pérou',
    },
    {
      id: 143,
      nationalite: 'qatarienne',
      libelle: 'Qatar',
    },
    {
      id: 148,
      nationalite: 'roumaine',
      libelle: 'Roumanie',
    },
    {
      id: 149,
      nationalite: 'britannique',
      libelle: 'Royaume-Uni',
    },
    {
      id: 150,
      nationalite: 'russe',
      libelle: 'Russie',
    },
    {
      id: 151,
      nationalite: 'rwandaise',
      libelle: 'Rwanda',
    },
    {
      id: 146,
      nationalite: 'dominicaine',
      libelle: 'République dominicaine',
    },
    {
      id: 145,
      nationalite: 'congolaise (RDC)',
      libelle: 'République démocratique du Congo',
    },
    {
      id: 147,
      nationalite: 'tchèque',
      libelle: 'République tchèque',
    },
    {
      id: 152,
      nationalite: 'christophienne',
      libelle: 'Saint-Christophe-et-Niévès',
    },
    {
      id: 154,
      nationalite: 'marinaise',
      libelle: 'Saint-Marin',
    },
    {
      id: 156,
      nationalite: 'vincentaise',
      libelle: 'Saint-Vincent-et-les Grenadines',
    },
    {
      id: 153,
      nationalite: 'lucienne',
      libelle: 'Sainte-Lucie',
    },
    {
      id: 157,
      nationalite: 'salomonaise',
      libelle: 'Salomon',
    },
    {
      id: 158,
      nationalite: 'salvadorienne',
      libelle: 'Salvador',
    },
    {
      id: 159,
      nationalite: 'samoene',
      libelle: 'Samoa',
    },
    {
      id: 160,
      nationalite: 'santoméenne',
      libelle: 'Sao Tomé-et-Principe',
    },
    {
      id: 162,
      nationalite: 'serbe',
      libelle: 'Serbie',
    },
    {
      id: 163,
      nationalite: 'seychelloise',
      libelle: 'Seychelles',
    },
    {
      id: 164,
      nationalite: 'sierraléonaise',
      libelle: 'Sierra Leone',
    },
    {
      id: 165,
      nationalite: 'singapourienne',
      libelle: 'Singapour',
    },
    {
      id: 166,
      nationalite: 'slovaque',
      libelle: 'Slovaquie',
    },
    {
      id: 167,
      nationalite: 'slovène',
      libelle: 'Slovénie',
    },
    {
      id: 168,
      nationalite: 'somalienne',
      libelle: 'Somalie',
    },
    {
      id: 169,
      nationalite: 'soudanaise',
      libelle: 'Soudan',
    },
    {
      id: 170,
      nationalite: 'srilankaise',
      libelle: 'Sri Lanka',
    },
    {
      id: 172,
      nationalite: 'suisse',
      libelle: 'Suisse',
    },
    {
      id: 173,
      nationalite: 'surinamaise',
      libelle: 'Suriname',
    },
    {
      id: 171,
      nationalite: 'suédoise',
      libelle: 'Suède',
    },
    {
      id: 174,
      nationalite: 'swazie',
      libelle: 'Swaziland',
    },
    {
      id: 175,
      nationalite: 'syrienne',
      libelle: 'Syrie',
    },
    {
      id: 161,
      nationalite: 'sénégalaise',
      libelle: 'Sénégal',
    },
    {
      id: 176,
      nationalite: 'tadjike',
      libelle: 'Tadjikistan',
    },
    {
      id: 178,
      nationalite: 'tanzanienne',
      libelle: 'Tanzanie',
    },
    {
      id: 177,
      nationalite: 'taïwanaise',
      libelle: 'Taïwan',
    },
    {
      id: 179,
      nationalite: 'tchadienne',
      libelle: 'Tchad',
    },
    {
      id: 180,
      nationalite: 'thaïlandaise',
      libelle: 'Thaïlande',
    },
    {
      id: 181,
      nationalite: 'timoraise',
      libelle: 'Timor oriental',
    },
    {
      id: 182,
      nationalite: 'togolaise',
      libelle: 'Togo',
    },
    {
      id: 183,
      nationalite: 'tongienne',
      libelle: 'Tonga',
    },
    {
      id: 184,
      nationalite: 'trinidadienne',
      libelle: 'Trinité-et-Tobago',
    },
    {
      id: 185,
      nationalite: 'tunisienne',
      libelle: 'Tunisie',
    },
    {
      id: 186,
      nationalite: 'turkmène',
      libelle: 'Turkménistan',
    },
    {
      id: 187,
      nationalite: 'turque',
      libelle: 'Turquie',
    },
    {
      id: 188,
      nationalite: 'tuvaluane',
      libelle: 'Tuvalu',
    },
    {
      id: 189,
      nationalite: 'ukrainienne',
      libelle: 'Ukraine',
    },
    {
      id: 190,
      nationalite: 'uruguayenne',
      libelle: 'Uruguay',
    },
    {
      id: 191,
      nationalite: 'vanuataise',
      libelle: 'Vanuatu',
    },
    {
      id: 192,
      nationalite: 'vénézuélienne',
      libelle: 'Venezuela',
    },
    {
      id: 193,
      nationalite: 'vietnamienne',
      libelle: 'Viêt Nam',
    },
    {
      id: 194,
      nationalite: 'yéménite',
      libelle: 'Yémen',
    },
    {
      id: 195,
      nationalite: 'zambienne',
      libelle: 'Zambie',
    },
    {
      id: 196,
      nationalite: 'zimbabwéenne',
      libelle: 'Zimbabwe',
    },
  ];
  //nationalite=["Afghan","Albanian","Algerian","American","Andorran","Angolan","Antiguans","Argentinean","Armenian","Australian","Austrian","Azerbaijani","Bahamian","Bahraini","Bangladeshi","Barbadian","Barbudans","Batswana","Belarusian","Belgian","Belizean","Beninese","Bhutanese","Bolivian","Bosnian","Brazilian","British","Bruneian","Bulgarian","Burkinabe","Burmese","Burundian","Cambodian","Cameroonian","Canadian","Cape Verdean","Central African","Chadian","Chilean","Chinese","Colombian","Comoran","Congolese","Costa Rican","Croatian","Cuban","Cypriot","Czech","Danish","Djibouti","Dominican","Dutch","East Timorese","Ecuadorean","Egyptian","Emirian","Equatorial Guinean","Eritrean","Estonian","Ethiopian","Fijian","Filipino","Finnish","French","Gabonese","Gambian","Georgian","German","Ghanaian","Greek","Grenadian","Guatemalan","Guinea-Bissauan","Guinean","Guyanese","Haitian","Herzegovinian","Honduran","Hungarian","I-Kiribati","Icelander","Indian","Indonesian","Iranian","Iraqi","Irish","Italian","Ivorian","Jamaican","Japanese","Jordanian","Kazakhstani","Kenyan","Kittian and Nevisian","Kuwaiti","Kyrgyz","Laotian","Latvian","Lebanese","Liberian","Libyan","Liechtensteiner","Lithuanian","Luxembourger","Macedonian","Malagasy","Malawian","Malaysian","Maldivan","Malian","Maltese","Marshallese","Mauritanian","Mauritian","Mexican","Micronesian","Moldovan","Monacan","Mongolian","Moroccan","Mosotho","Motswana","Mozambican","Namibian","Nauruan","Nepalese","New Zealander","Nicaraguan","Nigerian","Nigerien","North Korean","Northern Irish","Norwegian","Omani","Pakistani","Palauan","Palestine","Panamanian","Papua New Guinean","Paraguayan","Peruvian","Polish","Portuguese","Qatari","Romanian","Russian","Rwandan","Saint Lucian","Salvadoran","Samoan","San Marinese","Sao Tomean","Saudi","Scottish","Senegalese","Serbian","Seychellois","Sierra Leonean","Singaporean","Slovakian","Slovenian","Solomon Islander","Somali","South African","South Korean","Spanish","Sri Lankan","Sudanese","Surinamer","Swazi","Swedish","Swiss","Syrian","Taiwanese","Tajik","Tanzanian","Thai","Togolese","Tongan","Trinidadian or Tobagonian","Tunisian","Turkish","Tuvaluan","Ugandan","Ukrainian","Uruguayan","Uzbekistani","Venezuelan","Vietnamese","Welsh","Yemenite","Zambian","Zimbabwean"];
  //pays=["Îles Åland","Albanie","Algérie","afghanistan","Samoa américaines","Andorre","Angola","Anguilla","Antarctique","Antigua-et-Barbuda","Argentine","Arménie","Aruba","Australie","Autriche","Azerbaïdjan","Bahamas","Bahreïn","Bangladesh","Barbade","Biélorussie","Belgique","Belize","Bénin","Bermudes","Bhoutan","Bolivie","Bosnie-Herzégovine","Botswana","Île Bouvet","Brésil","British Virgin Islands","Territoire britannique de l’Océan Indien","Brunei Darussalam","Bulgarie","Burkina Faso","Burundi","Cambodge","Cameroun","Canada","Cap-Vert","Iles Cayman","République centrafricaine","Tchad","Chili","Chine","Hong Kong","Macao","Île Christmas","Îles Cocos","Colombie","Comores","République du Congo","République démocratique du Congo","Îles Cook","Costa Rica","Côte d’Ivoire","Croatie","Cuba","Chypre","République tchèque","Danemark","Djibouti","Dominique","République dominicaine","Équateur","Égypte","Salvador","Guinée équatoriale","Érythrée","Estonie","Éthiopie","Îles Falkland","Îles Féroé","Fidji","Finlande","France","Guyane française","Polynésie française","Terres australes et antarctiques françaises","Gabon","Gambie","Géorgie","Allemagne","Ghana","Gibraltar","Grèce","Groenland","Grenade","Guadeloupe","Guam","Guatemala","Guernesey","Guinée","Guinée-Bissau","Guyane","Haïti","Îles Heard-et-MacDonald","Saint-Siège (Vatican)","Honduras","Hongrie","Islande","Inde","Indonésie","Iran","Irak","Irlande","Ile de Man","Italie","Jamaïque","Japon","Jersey","Jordanie","Kazakhstan","Kenya","Kiribati","Corée du Nord","Corée du Sud","Koweït","Kirghizistan","Laos","Lettonie","Liban","Lesotho","Libéria","Libye","Liechtenstein","Lituanie","Luxembourg","Macédoine","Madagascar","Malawi","Malaisie","Maldives","Mali","Malte","Îles Marshall","Martinique","Mauritanie","Maurice","Mayotte","Mexique","Micronésie","Moldavie","Monaco","Mongolie","Monténégro","Montserrat","Maroc","Mozambique","Myanmar","Namibie","Nauru","Népal","Pays-Bas","Nouvelle-Calédonie","Nouvelle-Zélande","Nicaragua","Niger","Nigeria","Niue","Île Norfolk","Îles Mariannes du Nord","Norvège","Oman","Pakistan","Palau","Palestine","Panama","Papouasie-Nouvelle-Guinée","Paraguay","Pérou","Philippines","Pitcairn","Pologne","Portugal","Puerto Rico","Qatar","Réunion","Roumanie","Russie","Rwanda","Saint-Barthélemy","Sainte-Hélène","Saint-Kitts-et-Nevis","Sainte-Lucie","Saint-Martin (partie française)","Saint-Martin (partie néerlandaise)","Saint-Pierre-et-Miquelon","Saint-Vincent-et-les Grenadines","Samoa","Saint-Marin","Sao Tomé-et-Principe","Arabie Saoudite","Sénégal","Serbie","Seychelles","Sierra Leone","Singapour","Slovaquie","Slovénie","Îles Salomon","Somalie","Afrique du Sud","Géorgie du Sud et les îles Sandwich du Sud","Sud-Soudan","Espagne","Sri Lanka","Soudan","Suriname","Svalbard et Jan Mayen","Swaziland","Suède","Suisse","Syrie","Taiwan","Tadjikistan","Tanzanie","Thaïlande","Timor-Leste","Togo","Tokelau","Tonga","Trinité-et-Tobago","Tunisie","Turquie","Turkménistan","Îles Turques-et-Caïques","Tuvalu","Ouganda","Ukraine","Émirats Arabes Unis","Royaume-Uni","États-Unis","Îles mineures éloignées des États-Unis","Uruguay","Ouzbékistan","Vanuatu","Venezuela","Viêt Nam","Îles Vierges américaines","Wallis-et-Futuna","Sahara occidental","Yémen","Zambie","Zimbabwe"]
  colorDay = {
    totalDayFence: 'rgb(74, 120, 199)',
    totalDayClaire: 'rgb(149, 173, 216)',
    demiDayFence: 'rgb(74, 120, 199)',
    demiDayClaire: 'rgb(149, 173, 216)',
    textColorDefault: '#000000',
    backgroundDefault: 'rgb(0, 0, 0,0)',
    backgroundJourFerier: 'rgb(160, 156, 156)',
    backgroundWeek: '',
    textColorWeek: 'rgb(32, 60, 219)',
    backgroundOcupe: '#A52A2A',
    backgroundOcupeForNotSelectedTypePresentD: 'rgb(200,200,200)',
    textColorOcupe: '#000000',
    backgroundHorsDateAction: 'rgb(191, 196, 190)',
    backgroundDateAction: 'rgb(0, 0, 0,0);',
    textColorDateAction: 'green',
  };
  //pour google auto-complet
  componentForm = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    postal_code: 'short_name',
  };

  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  collaborateurConnecter: string = '';
  listeEcran = [
    { text: 'Mode de paiement', value: 'COM04', groupe: '', libelle: '' },
    { text: 'TVA', value: 'COM01', groupe: '', libelle: '' },
    { text: 'Mode de Facturation', value: 'COM02', groupe: '', libelle: '' },
    { text: 'Délai règlement', value: 'COM03', groupe: '', libelle: '' },
    { text: 'Type entreprise', value: 'CLI01', groupe: '', libelle: '' },
    {
      text: 'Type collaborateur',
      value: 'COL01',
      groupe: '',
      libelle: 'COLLABORATEURPRESTATAIRE',
    },
    { text: 'Compétence', value: 'COL02', groupe: '', libelle: '' },
    {
      text: 'Status',
      value: 'COL03',
      groupe: 'TYPECOLLABORATEUR',
      libelle: '',
    },
    {
      text: 'Temps collaborateur',
      value: 'COL05',
      groupe: 'TYPECOLLABORATEUR',
      libelle: 'TYPECONTRATCOLLABORATEUR',
    },
    { text: 'Type fonction', value: 'COL06', groupe: '', libelle: '' },
    { text: 'Type apprenant', value: 'COL07', groupe: '', libelle: '' },
    {
      text: 'Type rémunération',
      value: 'COL08',
      groupe: 'TYPECOLLABORATEUR',
      libelle: '',
    },
    { text: 'Unité Durée', value: 'COL09', groupe: '', libelle: '' },
    {
      text: 'Type contrat collaborateur',
      value: 'COL04',
      groupe: 'TYPECOLLABORATEUR',
      libelle: '',
    },
    {
      text: 'Type contrat apprenant',
      value: 'COL10',
      groupe: 'TYPEAPPRENANT',
      libelle: '',
    },
    {
      text: 'Modalités de la formation',
      value: 'COL12',
      groupe: '',
      libelle: '',
    },
    { text: 'Type candidat', value: 'COL13', groupe: '', libelle: '' },
    { text: 'Type document', value: 'DOC', groupe: '', libelle: '' },
    { text: 'Matière', value: 'MAT01', groupe: '', libelle: '' },
    { text: 'Type carburant', value: 'MACH01', groupe: '', libelle: '' },
    {
      text: 'Type équipements multimédia',
      value: 'MACH02',
      groupe: '',
      libelle: '',
    },
    {
      text: 'Type équipements industriels ',
      value: 'MACH03',
      groupe: '',
      libelle: '',
    },
    { text: 'Type équipements BTP', value: 'MACH04', groupe: '', libelle: '' },
    {
      text: 'Groupe type présence',
      value: 'ACTION01',
      groupe: '',
      libelle: '',
    },
    { text: 'Type présence', value: 'ACTION02', groupe: '', libelle: '' },
    { text: 'Batiment', value: 'SALL02', groupe: '', libelle: '' },
    { text: 'Type Action', value: 'TYPEACTION', groupe: '', libelle: '' },
    { text: 'Devise', value: 'DOCUMENT01', groupe: '', libelle: '' },
    { text: 'Nature des congés', value: 'CONGER01', groupe: '', libelle: '' },
  ];

  dialogConfig = new MatDialogConfig();

  // le coposons avtListeDocumentComponent il peux etre ouver en modal.
  // pour deffinir la variable fenetre au composon avtListeDocumentComponent, j'ai crée cette variable pour la remplacer
  fenetreAvtListeDocument: string;

  // le coposons ListeClient il peux etre ouver en modal.
  // pour deffinir la variable param au composon ListeClient, j'ai crée cette variable pour la remplacer
  paramListeClient: string;

  // le coposons ListeCollaborateur il peux etre ouver en modal.
  // pour deffinir la variable param au composon ListeColl, j'ai crée cette variable pour la remplacer
  paramListeColl: string;
  // document choisie par le  composon avtListeDocumentComponent
  rowChoisie;

  // le coposons avtListeMachineComponent il peux etre ouver en modal.
  // pour deffinir la variable type au composon avtListeMachineComponent, j'ai crée cette variable pour la remplacer
  fenetreAvtListeMachine: string;
  fenetreAvtListeMachineFilter;

  //machine  choisie par le  composon avtListeMachineComponent
  machineChoisie;

  // le coposons actionPrestation il peux etre ouver en modal.
  // pour deffinir la variable typeAction au composon actionPrestation, j'ai crée cette variable pour la remplacer
  fenetreTypeAction: string;

  // action choisie par le  composon avtDocumentComponent
  actionChoisie;

  // typesPublic pour les fenettre evenemant et liste evennement
  typesPublique = [
    { text: 'tout public', value: 0 },
    { text: 'liste groupe de formation', value: 1 },
    { text: 'formateur', value: 2 },
    { text: 'fonction support', value: 3 },
    { text: 'prestataires', value: 4 },
  ];

  // diffusions pour les fenettre evenemant et liste evennement
  // Attention!!  si tu à modifier la proprite value du Mur accueil modifier la dans evennement
  diffusions = [
    { text: 'Notification', value: 0 },
    { text: 'SMS', value: 1 },
    { text: 'Mail', value: 2 },
    { text: 'Mur accueil', value: 3 },
  ];
  // Attention!!  si tu à modifier l'un des proprite  value modifier la dans evennement
  listePositionEvennement = [
    { text: 'Au centre', value: 4 },
    { text: 'À droite', value: 5 },
    { text: 'À gauche', value: 6 },
  ];

  //type de machine
  listeMachine_Type = [
    { text: 'Véhicules', value: 1 },
    { text: 'Éqipement multimédia', value: 2 },
    { text: 'Équipement industriel', value: 3 },
    { text: 'Équipements BTP', value: 4 },
  ];
  typeSalle = [
    { DiverSys_Index: 1, DiverSys_Titre: 'salle' },
    { DiverSys_Index: 2, DiverSys_Titre: 'atelier' },
  ];
  facturableOrNotListe = [
    { text: 'Facturable', value: '1' },
    { text: 'Non facturable', value: '0' },
  ];
  planifiableOrNotListe = [
    { text: 'Planifiable', value: '1' },
    { text: 'Non planifiable', value: '0' },
  ];
  InclusDansCoursOrNotListe = [
    { text: "Inclus dans l'heure de cours", value: '1' },
    { text: "Non inclus dans l'heure de cours", value: '0' },
  ];
  typeAction = [
    { text: 'Action De Formation', value: '0' },
    { text: 'Action Administrative', value: '1' },
    { text: 'Action De Prestation', value: '2' },
  ];
  // le composon AvtMatiere peut etre ouvrir en modale,
  // dans ce ca je veux que le bouton liste matiere ne s'affiche pas
  showBtnListeMatiere: boolean = true;
  dialogOpend;
  param_code: string;
  typeTrs: string;
  typeClient: string;
  ajouterScroll: boolean = false;
  openedWindows;
  initDoc;
  CashR_Type = [
    {
      DiverSys_Libelle: 'Espèce',
      Diversys_Index: 0,
      icon: 'fas fa-money-bill-wave',
    },
    {
      DiverSys_Libelle: 'Chéque',
      Diversys_Index: 1,
      icon: 'fas fa-money-check',
    },
    {
      DiverSys_Libelle: 'TPE',
      Diversys_Index: 2,
      icon: 'fas fa-credit-card',
    },
    {
      DiverSys_Libelle: 'Ticket',
      Diversys_Index: 5,
      icon: 'fas fa-ticket-alt',
    },
  ];
  banques = [
    'BIAT',
    'BNA',
    'Attijari',
    'STB',
    'BH',
    'BTS',
    'BTE',
    'BTL',
    'TSB',
    'Zitouna',
    'Baraka',
    'Wifak',
    'Amen',
    'ABC',
    'BT',
    'Citi Banque',
    'QNB Tunis',
    'UBCI',
    'UIB',
    'BTK',
    'BFT',
  ];
  codeCaisse = 'C1';
  getCashRByIndex(index, CashR_Type?) {
    this.CashR_Type = CashR_Type;

    return this.CashR_Type.find((x) => x.Diversys_Index == index);
  }
  exportToExcel(listeDocumentComponen: AvtListesComponent, nameFile) {
    var dataToShow = listeDocumentComponen.dataSource.data.map((data) => {
      var row = {};
      listeDocumentComponen.displayedColumnsBrut.TableRD.forEach((col) => {
        // 7 => html
        // 100 => button
        // 8 => icon
        if (
          col.TableRD_Type != 7 &&
          col.TableRD_Type != 8 &&
          col.TableRD_Type != 100 &&
          col.TableRD_Type != 102 &&
          col.TableRD_Type != 103
        ) {
          if (col.TableRD_Type == 4 || col.TableRD_Type == 9) {
            var datePipe = new DatePipe('fr-FR');
            row[col.TableRD_Des] = datePipe.transform(
              data[col.TableRD_Champs],
              col.TableRD_Format
            );
          } else if (col.TableRD_Type == 6) {
            var decimalPipe = new DecimalPipe('fr-FR');
            row[col.TableRD_Des] = decimalPipe.transform(
              data[col.TableRD_Champs],
              col.TableRD_Format
            );
          } else row[col.TableRD_Des] = data[col.TableRD_Champs];
        }
      });
      return row;
    });

    var data = XLSX.utils.json_to_sheet(dataToShow);
    var wb = XLSX.utils.book_new(); // make Workbook of Excel
    XLSX.utils.book_append_sheet(wb, data, nameFile); // sheetAName is name of Worksheet
    XLSX.writeFile(wb, nameFile + '.xlsx'); // name of the file is 'book.xlsx'
  }
  clone(obj) {
    var copy;
    // Handle the 3 simple types, and null or undefined
    if (null == obj || 'object' != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.clone(obj[i]);
      }
      return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = this.clone(obj[attr]);
      }
      return copy;
    }
    throw new Error("Unable to copy obj! Its type isn't supported.");
  }
  isEgaleObject(obj1: Object, obj2: Object) {
    var str1 = JSON.stringify(obj1);
    var str2 = JSON.stringify(obj2);
    return str1 == str2;
  }

  rechercheTable(url: string, param?) {
    if (param) {
      return this.http.get(
        this.api + 'recherche/tbdata?tablere=' + url + '&param=' + param
      );
    }
    return this.httpGet(this.api + url);
  }

  rechercheTable2(url: string, param?) {
    if (param) {
      console.log(
        this.api + 'recherche/tbdata?tablere=' + url + '&param=' + param
      );
      return this.http.get(
        this.api + 'recherche/tbdata?tablere=' + url + '&param=' + param
      );
    } else {
      console.log(this.api + 'recherche/tbdata?tablere=' + url);
      return this.http.get(this.api + 'recherche/tbdata?tablere=' + url);
    }
  }

  httpGet(url: string) {
    return this.http.get<any>(url);
  }

  getDS(formdata, param?) {
    if (!param) {
      return this.http.get(this.api + 'ds/formdata?code=' + formdata);
    }
    return this.http.get(
      this.api + 'ds/formdata?code=' + formdata + '&val=' + param
    );
  }
  print(numTicket: any) {
    return this.http.get(
      'http://localhost:89/api/report/ImpDirect?code=tiket&val=' + numTicket
    );
  }

  async uploadFile(ArrayBuffer, files) {
    const formData = new FormData();
    var blob = await (await fetch(ArrayBuffer)).blob();
    formData.append('File', blob, files[0].name);

    return this.http.post(this.api + 'files', formData);
  }
  uploadFile2(blob, fileName: string) {
    const formData = new FormData();
    formData.append('File', blob, fileName);
    return this.http.post(this.api + 'files', formData);
  }
  enregisterTable(ds) {
    return this.http.post<any>(this.api + 'ds/post', ds);
  }
  enregisterCompte(ds) {
    return this.http.post<any>(this.api + 'users/register', ds);
  }
  modifierMosPass(ds) {
    return this.http.put<any>(this.api + 'users/client/resetPassword', ds);
  }
  public saveDA(data) {
    return this.http.post<any>(this.api + 'Document/Postdocsimple', data);
  }
  public saveDA2(data) {
    return this.http.post<any>(this.api + 'Document/Postdoc', data);
  }
  delete(data, codeform) {
    return this.http.get(
      this.api + 'ds/delete?data=' + data + '&formcode=' + codeform
    );
  }
  supprimer(id, ds) {
    if (confirm('Voulez-vous supprimer cet élément ?')) {
      /* si on clique sur ok */ return this.http.get(
        this.api + 'ds/delete?data=' + id + '&formcode=' + ds + '&control=1'
      );
    } else return null;
  }
  supprimerSanMsgConfirm(id, ds) {
    return this.http.get(
      this.api + 'ds/delete?data=' + id + '&formcode=' + ds + '&control=1'
    );
  }
  distinct(ds, attribut) {
    return ds
      .map((item) => eval('item.' + attribut))
      .filter((value, index, self) => self.indexOf(value) === index);
  }
  //methode temporere
  getFraisKm2() {
    return 0.5;
  }
  getFraisKm(km, avtTaux_NbrCh, tauxKm) {
    var res = 0;
    if (km < 50000) {
      if (avtTaux_NbrCh < 3) {
        res = km * tauxKm[0].avtTaux_Inf5;
      } else if (avtTaux_NbrCh == 4) {
        res = km * tauxKm[1].avtTaux_Inf5;
      } else if (avtTaux_NbrCh == 5) {
        res = km * tauxKm[2].avtTaux_Inf5;
      } else if (avtTaux_NbrCh == 6) {
        res = km * tauxKm[3].avtTaux_Inf5;
      } else {
        res = km * tauxKm[4].avtTaux_Inf5;
      }
    } else if (km > 5000 && km < 20000000) {
      if (avtTaux_NbrCh < 3) {
        res =
          km * tauxKm[0].avtTaux_Sup5Inf20Cof +
          tauxKm[0].avtTaux_Sup5Inf20Marge;
      } else if (avtTaux_NbrCh == 4) {
        res =
          km * tauxKm[1].avtTaux_Sup5Inf20Cof +
          tauxKm[0].avtTaux_Sup5Inf20Marge;
      } else if (avtTaux_NbrCh == 5) {
        res =
          km * tauxKm[2].avtTaux_Sup5Inf20Cof +
          tauxKm[0].avtTaux_Sup5Inf20Marge;
      } else if (avtTaux_NbrCh == 6) {
        res =
          km * tauxKm[3].avtTaux_Sup5Inf20Cof +
          tauxKm[0].avtTaux_Sup5Inf20Marge;
      } else {
        res =
          km * tauxKm[4].avtTaux_Sup5Inf20Cof +
          tauxKm[0].avtTaux_Sup5Inf20Marge;
      }
    } else {
      if (avtTaux_NbrCh < 3) {
        res = km * tauxKm[0].avtTaux_Sup20;
      } else if (avtTaux_NbrCh == 4) {
        res = km * tauxKm[1].avtTaux_Sup20;
      } else if (avtTaux_NbrCh == 5) {
        res = km * tauxKm[2].avtTaux_Sup20;
      } else if (avtTaux_NbrCh == 6) {
        res = km * tauxKm[3].avtTaux_Sup20;
      } else {
        res = km * tauxKm[4].avtTaux_Sup20;
      }
    }
    return res;
  }
  calculerFraisKm(row) {
    var somme = 0;
    if (parseFloat(row.avtFrais_TauxKm) >= 0)
      somme = parseFloat(row.avtFrais_TauxKm) * parseFloat(row.avtFrais_Km);
    if (parseFloat(row.avtFrais_NRM) >= 0)
      somme += parseFloat(row.avtFrais_NRM) * 3.5;
    if (parseFloat(row.avtFrais_NRS) >= 0)
      somme += parseFloat(row.avtFrais_NRS) * 18.4;
    if (parseFloat(row.avtFrais_NNH) >= 0)
      somme += parseFloat(row.avtFrais_NNH) * 49.4;
    if (parseFloat(row.avtFrais_Peage) >= 0)
      somme += parseFloat(row.avtFrais_Peage);
    if (parseFloat(row.avtFrais_Autre) >= 0)
      somme += parseFloat(row.avtFrais_Autre);
    return somme;
  }
  dialogSuccess(msg: string, status: boolean, duration = 6000) {
    let config = new MatSnackBarConfig();
    config.horizontalPosition = this.horizontalPosition;
    config.duration = duration;
    if (!status) config.panelClass = 'custom-class';
    else config.panelClass = 'custom-classGreen';
    this.snackBar.open(msg, true ? '' : undefined, config);
  }
  generateTreeData(docCollBrut) {
    var parentTree = [];
    docCollBrut.forEach((doc) => {
      //["a_attr"] = {myId:id};
      if (doc.File_Parent == null || doc.File_Parent == '')
        parentTree.push({
          id: doc.File_Id,
          parent: '#',
          text: doc.File_Text,
          a_attr: {
            myId: doc.File_Id,
            groupe: doc.File_Groupe,
            File_Lien: doc.File_Lien,
          },
          icon: doc.File_Dll,
        });
      else
        parentTree.push({
          id: doc.File_Id,
          parent: doc.File_Parent,
          text: doc.File_Text,
          a_attr: {
            myId: doc.File_Id,
            groupe: doc.File_Groupe,
            File_Lien: doc.File_Lien,
          },
          icon: doc.File_Dll,
        });
    });
    return parentTree;
  }

  addFiles(
    initDoc,
    File_Content,
    File_Text,
    File_Key,
    File_Type,
    File_Parent,
    clickMode,
    File_Groupe,
    File_Lien
  ) {
    var id;
    var doc = this.clone(initDoc);
    if (clickMode != 'renommer') {
      doc.files[0].File_Parent = File_Parent;
      doc.files[0].File_Content = File_Content;
      doc.files[0].File_Text = File_Text;
      doc.files[0].File_Key = File_Key;
      doc.files[0].File_Type = File_Type;
      doc.files[0].File_Groupe = File_Groupe;
      doc.files[0].File_Lien = File_Lien;
      if (clickMode == 'crerFichier') {
        doc.files[0].File_Dll = 'jstree-file';
      }
      if (clickMode == 'crerDossier') {
        doc.files[0].File_Dll = 'jstree-folder';
      }
      this.enregisterTable(doc).subscribe((data) => {
        this.dialogSuccess('Document enregistré', true);
      });
    }
    return id;
  }
  enregisterDoc(ds) {
    return this.http.put<any>(this.api + 'AvtDoc/put', ds);
  }
  removeNumberFromText(text: string) {
    if (text != null && text != undefined) {
      for (var i = 0; i < 10; i++) {
        do {
          text = text.replace(i.toString(), '');
        } while (text.indexOf(i.toString()) >= 0);
      }
    }

    return text;
  }
  removeTextFromNumber(text) {
    var num: string = '';
    for (var i = 0; i < text.length; i++) {
      var car = text.substring(i, i + 1);
      if (!isNaN(car)) num += car;
      else this.dialogSuccess('Veuillez saisir uniquement des nombres', false);
    }
    return num;
  }
  isEmpty(text): boolean {
    return !this.isNotEmpty(text);
  }
  isNotEmpty(text): boolean {
    if (text == null || text == undefined || text.toString() == '')
      return false;
    else return true;
  }
  generateListeFinanceur(
    listeFinanceur,
    listeModePaiement,
    listeTva,
    listeModeFacturation,
    listeDelaiReglement
  ) {
    listeFinanceur.forEach((financeur) => {
      //"avtCursusFinance_ModeFacturation":null,"avtCursusFinance_DelaiReglement"
      //type ModePaiement
      var ModePaiement = listeModePaiement.find((type) => {
        return type.DiverSys_Index == financeur.avtCursusFinance_ModePaiement;
      });
      if (ModePaiement != undefined) ModePaiement = ModePaiement.DiverSys_Titre;
      financeur['ModePaiement'] = ModePaiement;

      //Tva
      var tva = listeTva.find((type) => {
        return type.DiverSys_Index == financeur.avtCursusFinance_Tva;
      });
      if (tva != undefined) tva = tva.DiverSys_Titre;
      financeur['Tva'] = tva;

      //ModeFacturation
      var ModeFacturation = listeModeFacturation.find((type) => {
        return (
          type.DiverSys_Index == financeur.avtCursusFinance_ModeFacturation
        );
      });
      if (ModeFacturation != undefined)
        ModeFacturation = ModeFacturation.DiverSys_Titre;
      financeur['ModeFacturation'] = ModeFacturation;

      //DelaiReglement
      var DelaiReglement = listeDelaiReglement.find((type) => {
        return type.DiverSys_Index == financeur.avtCursusFinance_DelaiReglement;
      });
      if (DelaiReglement != undefined)
        DelaiReglement = DelaiReglement.DiverSys_Titre;
      financeur['DelaiReglement'] = DelaiReglement;
    });
    return listeFinanceur;
  }
  sort(liste, attribut) {
    liste.sort((a, b) => {
      const bandA = a[attribut].toString().toUpperCase();
      const bandB = b[attribut].toString().toUpperCase();
      let comparison = 0;
      if (bandA > bandB) comparison = 1;
      else if (bandA < bandB) comparison = -1;
      return comparison;
    });
    return liste;
  }
  popupCenter(url?, largeur?, hautteur?) {
    // Fixes dual-screen position                             Most browsers      Firefox
    if (!largeur)
      largeur =
        (window.innerWidth
          ? window.innerWidth
          : document.documentElement.clientWidth
          ? document.documentElement.clientWidth
          : screen.width) - 100;
    if (!hautteur)
      hautteur =
        (window.innerHeight
          ? window.innerHeight
          : document.documentElement.clientHeight
          ? document.documentElement.clientHeight
          : screen.height) - 100;
    const dualScreenLeft =
      window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop =
      window.screenTop !== undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : screen.width;
    const height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : screen.height;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - largeur) / 2 / systemZoom + dualScreenLeft;
    const top = (height - hautteur) / 2 / systemZoom + dualScreenTop;
    var myUrl = '';
    if (this.isNotEmpty(url)) myUrl = location.origin + url;
    var windows = window.open(
      myUrl,
      '_blank',
      `
          location=yes
          scrollbars=yes,
          status=yes,
          width=${largeur / systemZoom}, 
          height=${hautteur / systemZoom}, 
          top=${top}, 
          left=${left}
          `
    );
    return windows;
  }
  supprimerTableVideAction(myAction, tabProperty, property) {
    var action = JSON.parse(JSON.stringify(myAction));
    //   var tabProperty  = ["avtActionReferent","avtActionType","avtActionTypeD","avtactionDoc","avtAPH"]
    tabProperty.forEach((tab) => {
      var initAction = action[tab];
      if (this.isNotEmpty(initAction)) {
        if (initAction.length > 0) {
          for (var i = 0; i < initAction.length; i++) {
            if (!this.isNotEmpty(initAction[i][property])) {
              initAction.splice(i, 1);
            }
          }
        } else delete action[tab];
        if (action[tab].length == 0) delete action[tab];
      } else delete action[tab];
    });
    return action;
  }
  genererListeDocument(listeDocument) {
    listeDocument.forEach((fac) => {
      if (fac.Doc_Reliquat < fac.Doc_THT && fac.Doc_Reliquat > 0)
        fac['state'] =
          "<div style='width:10px;height:10px;background-color: rgb(245, 138, 16)'>&nbsp;</div>";
      else if (fac.Doc_Reliquat == 0 || !this.isNotEmpty(fac.Doc_Reliquat))
        fac['state'] =
          "<div style='width:10px;height:10px;background-color: rgb(34,139,34)'>&nbsp;</div>";
      else if (fac.Doc_Reliquat >= fac.Doc_THT)
        fac['state'] =
          "<div style='width:10px;height:10px;background-color: rgb(165,42,42)'>&nbsp;</div>";
      else
        fac['state'] =
          "<div style='width:10px;height:10px;background-color: rgb(104, 109, 104)'>&nbsp;</div>";
    });
    return listeDocument;
  }
  isVersionPortable(nimWidth: number): boolean {
    if (this.getWidth() < nimWidth) return true;
    else return false;
  }
  getWidth(): number {
    return window.innerWidth;
  }
  printContents(contents: string) {
    var html = document.getElementById(contents).innerHTML;
    var a = this.popupCenter('/w/print');
    a.addEventListener('load', () => {
      a.document.body.innerHTML = html;
      a.document.close();
      setTimeout(() => {
        a.print();
      }, 100);
    });
  }
  printContentsTest(contents: string, url: string) {
    var html = document.getElementById(contents).innerHTML;
    var a = this.popupCenter('/w/print');
    a.addEventListener('load', () => {
      a.document.write('<img src="' + url + '" />');
      a.document.write(html);
      //a.document.close();
      setTimeout(() => {
        a.print();
        //history.go(0)
      }, 100);
    });
  }

  getJWT() {
    const token: any = localStorage.getItem('token');
    return token.accessToken;
  }
  getPackageSchema() {
    return this.http.get(this.api + 'ds/formdata?code=colisd', this.getJWT());
  }
  tbRecherche(name) {
    return this.http.get(this.api + 'recherche/tbRecherche?param=' + name);
  }

  getPackage(codeVal) {
    return this.http.get(
      this.api + 'ds/formdata?code=colis&val=' + codeVal,
      this.getJWT()
    );
  }
  postPackage(data) {
    return this.http.post(this.api + 'ds/post', data);
  }
  postDs(data) {
    return this.http.post(this.api + 'ds/post', data);
  }
  getUserSite() {
    return this.http.get(
      this.api + 'recherche/tbdata?tablere=UserSite',
      this.getJWT()
    );
  }
  setUserSites(userSite) {
    let userSites: Array<any> =
      JSON.parse(localStorage.getItem('userSites')) || [];
    if (userSites.indexOf(userSite) == -1) {
      userSites.push(userSite);
      localStorage.setItem('userSites', userSite);
    }
  }
  getFicheClient(Tier_code) {
    return this.http.get(
      this.api + 'recherche/tbdata?tablere=Tier&param=' + Tier_code,
      this.getJWT()
    );
  }
  getHierarchieFromNode(node) {
    return this.http.get(
      this.api + 'ds/formdata?code=ArtAxe&val=' + node,
      this.getJWT()
    );
  }
  addHierarchieNode({ child, parent, type, code }) {
    const body = {
      ArtAxe: [
        {
          id: null,
          U_timestamp: null,
          ArtAxe_Chlid: child,
          ArtAxe_Parent: parent,
          ArtAxe_Type: type,
          ArtAxe_Code: code,
        },
      ],
      ApiForm: [
        {
          For_Code: 'ArtAxe',
          For_Val: '',
        },
      ],
    };
    return this.http.post(this.api + 'ds/post', body, this.getJWT());
  }
  getDepartPackages() {
    return this.http.get(
      this.api + 'recherche/tbdata?tablere=apiColisDepart',
      this.getJWT()
    );
  }
  getEncourPackages() {
    return this.http.get(
      this.api + 'recherche/tbdata?tablere=apiColisEncours',
      this.getJWT()
    );
  }
  getArrivePackages(days = 0) {
    return this.http.get(
      this.api + 'recherche/tbdata?tablere=apiColisArrive&param=' + days,
      this.getJWT()
    );
  }
  getImgSrc(guid) {
    return this.flatEndPoint + 'images/' + guid;
  }

  downlodeFile(downlode_file_url) {
    return this.http.get(downlode_file_url, { responseType: 'blob' });
  }
  customRequest(fullUrl, method = 'get', body?) {
    if (method == 'get') return this.httpGet(fullUrl);
    else return this.http.post(fullUrl, body);
  }
  roundToFixed(number, DicimalAllowed = 3) {
    let x = Math.pow(10, DicimalAllowed);
    return Math.round(number * x) / x;
  }
  convertDatefromat(date) {
    // 3amchharyom
    const year = new Date(date).getFullYear();
    const mounth = new Date(date).getMonth() + 1;
    const day = new Date(date).getDate();

    return year + '' + mounth + day;
  }
  fillObject(objFrom, ObjTo) {
    //read keys from the webform
    var ListKeys = Object.keys(objFrom);
    var ListKeysTo = Object.keys(ObjTo);
    //fill into ds from webform

    ListKeys.forEach((element2) => {
      if (ListKeysTo.find((e) => e == element2))
        ObjTo[element2] = objFrom[element2];
    });
    return ObjTo;
  }
  createObj(List) {
    var objet = {};
    List.forEach((element) => {
      objet[element] = null;
    });
    return objet;
  }
  clearFields(object) {
    var ListKeys = Object.keys(object);
    //clear fields
    ListKeys.forEach((element2) => {
      object[element2] = null;
    });
    return object;
  }

  ConvertisseurDureeEnChaine_Generic(minute) {
    var h = Math.floor(minute / 60);
    var m = minute % 60;
    if (h == 0) return m + 'm';
    else if (m == 0) return h + 'h';
    else return h + 'h ' + m + 'm';
  }
}
